<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card v-if="commn_data!=null">
      <v-card-title>Communication status</v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col style="text-align:left" md="2" sm="2">
            Date:
            <b>{{commn_data.communication_date}}</b>
          </v-col>
          <v-col style="text-align:center" md="6" sm="6">
            Title:
            <b>{{commn_data.title}}</b>
          </v-col>
          <!-- <v-col style="text-align:right" md="2" sm="2">
            AY:
            <b>{{commn_data.academicyear}}</b>
          </v-col> -->
        </v-row>
        <v-row justify="center" v-if="commn_data.description!='null'">
          <v-col style="text-align:left" md="3" sm="3"><b>Description: {{commn_data.description}}</b></v-col>
        </v-row>
      </v-card-text>
    </v-card>
        <br />
    <v-card v-if="status_list!=null">
      <v-card-text>
        <v-data-table :headers="headers" :items="status_list" :search="search"  :items-per-page="-1">
          <template v-slot:top>
            <v-toolbar flat color="white" align="center" justify="center">
              <v-toolbar-title>List of Receipients</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:item.is_read="{ item }">
            <v-icon
              small
              class="mr-2"
            >{{item.is_read?'mdi-eye-check-outline':'mdi-eye-off-outline'}}</v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    snackbar_msg: "",
    snackbar: false,
    color: "",
    //
    commn_id: null,
    commn_data: {
      title: null,
      description: null,
      communication_date: null,
      academicyear: null
    },
    status_list: null,
    search: "",
    headers: [
      { text: "User", value: "user" },
      //{ text: "Grno", value: "grno" },
      { text: "Read", value: "is_read" },
      { text: "Read On", value: "read_date" }
    ]
  }),
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    }
  },
  mounted() {
    this.commn_id = localStorage.getItem("commn_id");
    console.log(this.commn_id);
    const formData = {
      commn_id: this.commn_id
    };
    axios
      .post("communicationGroup/getStatus", formData)
      .then(res => {
        if (res.data.status == "SUCCESS") {
          this.status_list = res.data.status_list;
          this.commn_data = res.data.commn_data;
          //this.showSnackbar("#4CAF50","Success")
        } else {
          this.showSnackbar("#b71c1c", res.data.status_reason);
        }
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong!!!");
      })
      .finally(() => {});
  }
};
</script>